export enum ProviderDataReviewStatus {
  open = 'open',
  closed = 'closed',
}